export const WatchListViewModes = {
  SINGLE: 'single',
  MULTI: 'multi'
} as const;

export type WatchListViewModeType = (typeof WatchListViewModes)[keyof typeof WatchListViewModes];
